/* eslint-disable max-lines */
/* eslint-disable import/no-default-export */
import { ca } from '@cian/analytics';
import { get } from 'lodash';
import { FAILED_PUBLISH_LABEL } from '../../../../shared/constants';
import { selectAnalyticsOfferStatus } from '../../../../shared/selectors/analytics';
import { getClientDeviceType, getDealAndObjectType } from '../../../../shared/utils';
import { isNewOffer } from './ad-state.service';
import { trackNavigationClick } from './analytics/navigation';

/**
 * @deprecated Используй selectAnalyticsOfferStatus
 */
export const adAnalyticsCategory = isNewOffer ? 'New_ad' : 'Edit_ad';

export default [
  '$rootScope',
  'store',
  'formIdService',
  ($rootScope, store, formIdService) => {
    const handleParams = paramsArray => paramsArray.filter(Boolean).join('/');

    /**
     * По телу ответа сервера определяем метку для события с ошибкой
     */
    const getLabelByResponseData = responseData => {
      const { status, data: errorData } = responseData;

      if (status === 403) {
        return FAILED_PUBLISH_LABEL.UNAUTHORIZED;
      }

      let requiredError = 0;
      let invalidError = 0;

      for (let i in errorData) {
        if (Array.isArray(errorData[i])) {
          requiredError = requiredError || errorData[i].some(el => el && el['code'] === 'required');
          invalidError = invalidError || errorData[i].some(el => el && ['invalid', 'type'].indexOf(el['code']) >= 0);
        }
      }

      if (requiredError > 0) {
        return FAILED_PUBLISH_LABEL.UNFILLED;
      }
      if (invalidError > 0) {
        return FAILED_PUBLISH_LABEL.MISFILLED;
      }

      return FAILED_PUBLISH_LABEL.UNKNOWN;
    };

    const getUserType = isHomeowner => (isHomeowner ? 'user' : 'agent');

    const getOfferStatus = () => {
      const state = store.getState();

      return selectAnalyticsOfferStatus(state);
    };

    const makePublishFailedByTypeAction = ({ type, isShortForm, offerId }) => ({
      name: 'oldEvent',
      category: getOfferStatus(),
      action: 'FailedToPublish',
      oid: offerId,
      label: type,
      page: {
        pageType: 'AddForm',
        siteType: getClientDeviceType(),
        extra: {
          form_type: isShortForm ? 'short' : 'full',
        },
      },
    });

    let isStep2AnalyticsSent = false;

    return {
      adAnalyticsCategory,

      authUser(userID, email) {
        ca('user', {
          userID,
          email,
        });
      },

      socialAuth(type) {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: `tab_auth_${type}_click`,
        });
      },

      socialRegister(type) {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: `tab_reg_${type}_click`,
        });
      },

      successSocialAuth(type) {
        ca('event', {
          name: 'oldevent',
          category: 'Authorization',
          action: `new_ad_${type}`,
        });
      },

      successSocialRegister(type) {
        ca('event', {
          name: 'oldevent',
          category: 'Registration',
          action: `new_ad_${type}`,
          label: 'user',
        });
      },

      successMergeAccount(type) {
        ca('event', {
          name: 'oldevent',
          category: 'Authorization',
          action: 'new_ad_link_accounts',
          label: type,
        });
      },

      registrationTab() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'auth_popup_tab_reg_open',
        });
      },

      loginTab() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'auth_popup_tab_auth_open',
        });
      },

      showAuthorized() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'auth_popup_view',
          label: 'auth',
        });
      },

      forgotPassword() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'auth_popup_tab_auth_click',
          label: 'forgot_password_click',
        });
      },

      successSubmitForgotPassword() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'auth_popup_tab_auth_click',
          label: 'forgot_password_send',
        });
      },

      // Успешная авторизация
      successAuthorized() {
        ca('event', {
          name: 'oldevent',
          category: 'Authorization',
          action: getOfferStatus(),
        });
      },

      trySubmitRegistration() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'auth_popup_tab_reg',
          label: 'try_to_send',
        });
      },

      // Показ блока с соц. сетями и полем для ввода пароля
      authLastStepShow(isHomeowner) {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'auth_block_view',
          label: getUserType(isHomeowner),
        });
      },

      // Клик по иконке соц. сети
      socClick(type) {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: `${type}_click`, // vk_click|fb_click|google_click|mailru_click|ok_click
          label: '',
        });
      },

      // Успешная авторизация через соц.сеть
      successfulSocLogin(type) {
        ca('event', {
          name: 'oldevent',
          category: 'Authorization',
          action: `${type}_click`, // vk_click|fb_click|google_click|mailru_click|ok_click
          label: '',
        });
      },

      // Успешная регистрация через соц.сеть
      successfulSocRegistration(type) {
        ca('event', {
          name: 'oldevent',
          category: 'Registration',
          action: `${type}_click`, // vk_click|fb_click|google_click|mailru_click|ok_click
          label: '',
        });
      },

      // Если пользователь найден, и раскрывается поле ввода пароля
      authEmailFound(isHomeowner) {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'password_block_view',
          label: getUserType(isHomeowner),
        });
      },

      // Если пользователь не найден, и раскрывается форма регистрации
      authEmailNotFound(isHomeowner) {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'reg_block_view',
          label: getUserType(isHomeowner),
        });
      },

      // Успешное подтверждение телефона
      authPhoneConfirmation() {
        ca('event', {
          name: 'oldevent',
          category: 'Confirm_phone',
          action: 'confirmed_new_ad',
          label: '',
        });
      },

      // Успешная регистрация
      successfulRegistration(userType) {
        ca('event', {
          name: 'oldevent',
          category: 'Registration',
          action: getOfferStatus(),
          label: userType,
        });
      },

      addFormStep1() {
        ca('eventSite', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'step1',
          page: {
            pageType: 'AddForm',
            extra: {
              form_id: formIdService.getId(),
            },
          },
        });
      },

      addFormStep2(category) {
        const { dealType, objectType } = getDealAndObjectType(category);

        const eventExist = window.dataLayer?.some(item => {
          return item.eventCategory === 'New_ad' && item.eventAction === 'step2';
        });

        if (isStep2AnalyticsSent || eventExist) {
          return;
        }

        ca('eventSite', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'step2',
          label: `${dealType}/${objectType}`,
          page: {
            pageType: 'AddForm',
            extra: {
              form_id: formIdService.getId(),
            },
          },
        });

        isStep2AnalyticsSent = true;
      },

      setLongForm() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'tab_full_form_open',
        });
      },

      setShortForm() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'tab_short_form_open',
        });
      },

      publishSuccess(isShortForm, category) {
        const { dealType, objectType } = getDealAndObjectType(category);

        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: isShortForm ? 'tab_short_form_success' : 'tab_full_form_success',
          label: `${dealType}/${objectType}`,
        });
      },

      publishByUnauthorizedFailed({ isShortForm, offerId }) {
        ca('eventSite', {
          ...makePublishFailedByTypeAction({
            type: FAILED_PUBLISH_LABEL.UNAUTHORIZED,
            isShortForm,
            offerId,
          }),
        });
      },

      publishByPrepublishFailed({ isShortForm, offerId }) {
        ca('eventSite', {
          ...makePublishFailedByTypeAction({
            type: FAILED_PUBLISH_LABEL.PREPUBLISH,
            isShortForm,
            offerId,
          }),
        });
      },

      publishFailedByResponse({ responseData, isShortForm, offerId }) {
        if (responseData) {
          ca('eventSite', {
            ...makePublishFailedByTypeAction({
              type: getLabelByResponseData(responseData),
              isShortForm,
              offerId,
            }),
          });
        }
      },

      /**
       * Сохранение черновика перед идентификацией по паспорту в sumsub
       */
      saveDraftIdentification(category) {
        const { dealType, objectType } = getDealAndObjectType(category);
        const eventParamsStr = handleParams([dealType, objectType]);

        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'save_draft_identification',
          label: eventParamsStr,
        });
      },

      clearForm() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'clear_form',
        });
      },

      start() {
        ca('eventSite', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'start',
          page: {
            pageType: 'AddForm',
            extra: {
              form_id: formIdService.getId(),
            },
          },
        });
      },

      trackAdvertiseCheckboxShow() {
        ca('event', {
          name: 'oldevent',
          category: 'PromoteObject',
          action: 'Show',
          label: 'Try_form',
        });
      },

      trackAdvertiseBannerClick() {
        ca('event', {
          name: 'oldevent',
          category: 'PromoteObject',
          action: 'Click',
          label: 'Try_form',
        });
      },

      trackAdvertiseRequestSend() {
        ca('event', {
          name: 'oldevent',
          category: 'PromoteObject',
          action: 'Submit',
          label: 'Try_form',
        });
      },

      trackCommunicationHelperShow() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'communication_banner_show',
          label: '',
        });
      },

      trackCommunicationClick(label) {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'communication_banner_click',
          label,
        });
      },

      trackPhoneVerifyShow() {
        ca('eventSite', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'show',
          label: 'phone_block',
        });
      },

      trackSelfEmployedShow() {
        ca('eventSite', {
          name: 'oldevent',
          category: 'New_ad',
          action: 'selfemployed_show',
        });
      },

      trackRosreestrShow() {
        ca('eventSite', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'Show',
          label: 'rosreestr_data',
        });
      },

      trackReportErrorModalShow() {
        ca('eventSite', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'Click',
          label: 'report_a_problem',
        });
      },

      trackReportErrorModalSend() {
        ca('eventSite', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'Send',
          label: 'report_a_problem',
        });
      },

      getGATermsString(terms) {
        /**
         * Условия размещения могут отсутствовать если размещение в закрытую базу
         */
        if (!terms) {
          return;
        }
        var services = [];
        angular.forEach(terms.terms, term => {
          angular.forEach(term.services, service => {
            let serv = service;
            if (serv === 'highlight') {
              serv = 'color';
            } else if (serv === 'paid') {
              serv = 'pay';
            }
            if (services.indexOf(serv) < 0) {
              if (serv === 'color') {
                services.push(serv);
              } else {
                services.unshift(serv);
              }
            }
          });
        });

        return services.join('_');
      },

      sendPromoteAdComplete(terms, offerId, amount, state, isAdvertiseEnabled) {
        const action = isNewOffer ? 'new' : 'old';
        const advertiseState = isAdvertiseEnabled ? 'true' : 'false';
        const newGATerms = this.getGATermsString(terms);

        let oldGATerms = '';

        if ($rootScope.savedOffer && $rootScope.savedOffer.publishTerms) {
          oldGATerms = this.getGATermsString($rootScope.savedOffer.publishTerms);
        }

        ca('event', {
          name: 'oldevent',
          category: 'Promote_ad_complete',
          // new — новое объявление, old — редактируемое
          action,
          // id объявления/старый vas/новый vas/сумма/состояние коллтрекинга
          label: [offerId, oldGATerms, newGATerms, amount, state, advertiseState].join('/'),
        });
      },

      adPublished({ offer, isRealtorHelpNeeded, publishType, isShortForm, offerStatus, publishTerms }) {
        const isSelfEmployed = get(offer, 'selfEmployedData.inn', false);
        const { category, isByHomeowner, video, id: offerId } = offer;

        /*
        Х передает информацию о типе сделки и типе объекта: rent|sale|daily_rent/flat|commercial|suburban
        + о факте прикрепления видео к объявлению
        + хочет ли получить помощь риэлтора
        Пример:
      */
        const { dealType, objectType } = getDealAndObjectType(category);
        const ownerParam = `owner=${+!!isByHomeowner}`;
        const selfEmployedParam = `selfemployed=${+!!isSelfEmployed}`;
        const videoParam = `video=${+!!(Array.isArray(video) && video.length > 0)}`;
        const realtorHelp = `realtor_help=${+isRealtorHelpNeeded}`;
        const formId = `form_id=${window.formId}`;

        const eventParams = [dealType, objectType, ownerParam, videoParam, selfEmployedParam, realtorHelp, formId];

        const eventParamsStr = handleParams(eventParams);

        ca('eventSite', {
          name: 'oldevent',
          category: offerStatus,
          action: 'success',
          label: eventParamsStr,
          oid: offerId,
          products: [
            {
              id: offerId,
              offerType: 'offer',
              position: 1,
            },
          ],
          page: {
            pageType: 'AddForm',
            form_type: isShortForm ? 'short' : 'full',
            extra: {
              publish_type: publishType,
              form_id: formIdService.getId(),
              publishTerms,
            },
            siteType: getClientDeviceType(),
          },
        });
      },

      enableChats() {
        ca('event', {
          name: 'oldevent',
          category: getOfferStatus(),
          action: 'messages_on',
          label: '',
        });
      },

      trackNavigationClick(segment) {
        trackNavigationClick(segment);
      },

      trackChangeType(ea, el) {
        ca('eventSite', {
          name: 'oldevent',
          category: 'New_ad',
          action: ea,
          label: el,
          page: {
            pageType: 'AddForm',
            extra: {
              form_id: formIdService.getId(),
            },
          },
        });
      },
    };
  },
];
